//#region src/components/Icon/BigIcon/BigIcon.module.css
var BigIcon_module_default = { "big-icon": "_big-icon_1ssbv_8" };
//#endregion
export { BigIcon_module_default as default };

//# sourceMappingURL=BigIcon.module.js.map